import AboutHUSDModal from 'components/AboutHUSDModal'
import useModal from 'hooks/useModal'
import Column, { ColumnCenter } from 'layout/Components/Column'
import { RowBetween, RowCenter } from 'layout/Components/Row'
import { Icons } from 'svgs'
import theme from 'theme'

import { HUSD_TOKEN } from 'config/constants/tokens'
import { Trans } from 'react-i18next'
import { useHUSDLockBonus } from 'state/bonus/hooks'
import { useTokenAppBalance } from 'state/profile/hooks'
import IconButton from 'UIKit/Button/IconButton'
import Image from 'UIKit/Image'
import Text from 'UIKit/Text'
import TokenLogo from 'UIKit/TokenLogo'
import { getFullDisplayBalance } from 'utils/formatBalance'
import { StyledSelectTrigger } from '../DesktopPayment/components/PaymentSelect'
import { PaymentInputContainer, PaymentLabel, StyledActionButton } from '../MobilePayment/components/styles'

const HUSDInfo: React.FC<{
  onRedirectToSwap?: () => void
}> = ({ onRedirectToSwap }) => {
  const [handlePresentHUSDInfo] = useModal(AboutHUSDModal)
  const { claimableBalance, unlockableBalance } = useHUSDLockBonus()
  const balance = useTokenAppBalance(HUSD_TOKEN)
  const unlockableAmount = unlockableBalance.minus(claimableBalance)

  return (
    <Column gap="20px" position="relative">
      <Column padding="12px">
        <RowCenter>
          <Image width={120} height={60} src="/images/HUSD-coin-group.png" alt="husd group" />
        </RowCenter>
        <ColumnCenter gap="4px">
          <Text textAlign="center" fontSize="18px" bold>
            HunnyPlay Dollar
          </Text>
          <Text textAlign="center" fontSize="18px" bold color="#34C759">
            1 HUSD = 1 USD ($1.00)
          </Text>
        </ColumnCenter>
        <Text textAlign="center" small color={`var(--pm-label-color,${theme.colors.text_secondary})`}>
          <Trans>Play any games and earn your HUSD</Trans>
        </Text>
      </Column>

      {unlockableAmount.gt(0) && (
        <PaymentInputContainer
          style={{
            display: 'flex',
            flexDirection: 'column',
          }}
          padding="12px"
          gap="0"
          height="auto"
        >
          <Text textAlign="center" display="inline" fontSize="32px" bold>
            <span>{getFullDisplayBalance(unlockableAmount, 0, 2)}</span>
            <Text display="inline" small bold ml="4px">
              HUSD
            </Text>
          </Text>

          <Text textAlign="center" small color="var(--pm-label-color)" mt="4px" mb="12px">
            <Trans>Unlockable Amount</Trans>
          </Text>
          <StyledSelectTrigger
            background="var(--pm-card-active)"
            backgroundHover="var(--pm-card-active-hover)"
            onClick={handlePresentHUSDInfo}
          >
            <RowBetween>
              <Text color="primary" small bold>
                <Trans>How to unlock HUSD?</Trans>
              </Text>
              <IconButton width={12}>
                <Icons.ChevronRightIcon fill="current" width="8px" />
              </IconButton>
            </RowBetween>
          </StyledSelectTrigger>
        </PaymentInputContainer>
      )}

      <PaymentInputContainer
        style={{
          display: 'flex',
          flexDirection: 'column',
        }}
        padding="12px"
        gap="0"
        height="auto"
      >
        <Text textAlign="center" display="inline" fontSize="32px" bold>
          <span>{getFullDisplayBalance(balance.amount, 0, 2)}</span>
          <Text display="inline" small bold ml="4px">
            HUSD
          </Text>
        </Text>

        <Text textAlign="center" small color="var(--pm-label-color)" mt="4px" mb="12px">
          <Trans>Your balance</Trans>
        </Text>
        {onRedirectToSwap && (
          <StyledActionButton onClick={onRedirectToSwap} width="100%" maxWidth="280px">
            <Trans>Swap</Trans>
          </StyledActionButton>
        )}
      </PaymentInputContainer>

      <PaymentInputContainer padding="12px" height="auto">
        <TokenLogo token={HUSD_TOKEN} size={44} />
        <Column gap="2px">
          <Text small bold color="white">
            <Trans>Earn HUSD</Trans>
          </Text>
          <Text fontSize="var(--pm-text-note-size)" color="var(--pm-text-note-color)">
            <Trans>
              Spin the Lucky Spin, collect daily rewards, catch airdrops, and finish missions — each bet unlocks more
              HUSD.
            </Trans>
          </Text>
        </Column>
      </PaymentInputContainer>

      {unlockableAmount.lte(0) && (
        <Column gap="var(--pm-space-label)">
          <PaymentLabel>
            <Trans>Learn more</Trans>
          </PaymentLabel>

          <StyledSelectTrigger
            background="var(--pm-card-active)"
            backgroundHover="var(--pm-card-active-hover)"
            onClick={handlePresentHUSDInfo}
          >
            <RowBetween>
              <Text color="currentColor">
                <Trans>Learn more about HUSD</Trans>
              </Text>
              <IconButton width={12}>
                <Icons.ChevronRightIcon fill="current" width="8px" />
              </IconButton>
            </RowBetween>
          </StyledSelectTrigger>
        </Column>
      )}
    </Column>
  )
}

export default HUSDInfo
